// extracted by mini-css-extract-plugin
export default {"privacyPolicyPage":"PrivacyPolicyPage_privacyPolicyPage__gprrK"};